import { Link } from 'react-router-dom';
import { useT } from '@kmgestao/i18n';
import { PageSectionCard } from '@kmgestao/ui';

/**
 * Card de atalhos pra principais áreas do painel da clinic. Substitui
 * "menu lateral oculto em mobile" — owner vê os atalhos diretamente.
 *
 * Cada link usa tokens DS (`bg-card`, `text-foreground`, etc) e tem
 * tap target ≥ 44×44 (padding generoso).
 */
export function QuickActionsCard() {
  const { t } = useT('clinics');

  const actions = [
    {
      id: 'profile',
      href: '/perfil',
      titleKey: 'dashboard.quickActions.profile.title',
      descKey: 'dashboard.quickActions.profile.description',
    },
    {
      id: 'plan',
      href: '/plano',
      titleKey: 'dashboard.quickActions.plan.title',
      descKey: 'dashboard.quickActions.plan.description',
    },
    {
      id: 'team',
      href: '/equipe',
      titleKey: 'dashboard.quickActions.team.title',
      descKey: 'dashboard.quickActions.team.description',
    },
    {
      id: 'appearance',
      href: '/identidade-visual',
      titleKey: 'dashboard.quickActions.appearance.title',
      descKey: 'dashboard.quickActions.appearance.description',
    },
    {
      id: 'ai',
      href: '/settings/ai',
      titleKey: 'dashboard.quickActions.ai.title',
      descKey: 'dashboard.quickActions.ai.description',
    },
  ] as const;

  return (
    <PageSectionCard
      title={t('dashboard.quickActions.title')}
      description={t('dashboard.quickActions.description')}
      contentClassName="space-y-4"
    >
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {actions.map((action) => (
          <Link
            key={action.id}
            to={action.href}
            className="rounded-lg border border-border bg-card p-4 transition-colors hover:border-primary hover:bg-accent/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
          >
            <p className="text-sm font-semibold text-foreground">{t(action.titleKey)}</p>
            <p className="mt-1 text-xs text-muted-foreground">{t(action.descKey)}</p>
          </Link>
        ))}
      </div>
    </PageSectionCard>
  );
}
